const UserVacanciesAdapter = data => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    outlet_village: i.shopping_center?.title,
    user: `${i.user?.name} ${i.user?.surname}`,
    file_name: i.doc?.file_name,
    file: i.doc?.url
  });

  if (Array.isArray(data)) {
    data.forEach(i => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default UserVacanciesAdapter;